import React from 'react';

export default function ThirdPartyFix() {
    if (document && document.getElementById) {
        const kfc = document.getElementById('kampyleFormContainer');
        if (kfc) {
            kfc.style.height = 'unset';
        }
    }

    return null;
}
